// extracted by mini-css-extract-plugin
module.exports = {"noBorder":"GuestForms_noBorder__-X8Os"};